import { Button } from '@act/storybook';
import { CircularProgress } from '@mui/material';
import styled from 'styled-components';
import AccordionSection from './accordionSection';
import NumberedSection from './numberedSection';
import ParagraphSection from './paragraphSection';

export const SECTION_TYPES = {
  accordion: <AccordionSection />,
  numbered: <NumberedSection />,
  paragraph: <ParagraphSection />,
};

export const ProgressContainer = styled.div`
  display: grid;
  place-items: center;
  height: 100px;
  width: 100%;
`;

export const ProgressContainerWithSpinner = () => (
  <ProgressContainer aria-label="Loading spinner">
    <CircularProgress />
  </ProgressContainer>
);

interface WorkflowButtonGroupProps {
  handleBack: () => void;
  handleNext: () => void;
  disableBack?: boolean;
  disableNext?: boolean;
  nextLabel?: string;
}

export const WorkflowButtonGroup = ({
  handleBack,
  handleNext,
  disableBack,
  disableNext,
  nextLabel,
}: WorkflowButtonGroupProps) => {
  return (
    <div>
      <Button onClick={handleBack} disabled={disableBack || false}>
        Previous
      </Button>
      <Button
        delay={1000}
        disabled={disableNext || false}
        onClick={handleNext}
        debounced
      >
        {nextLabel ?? 'Next'}
      </Button>
    </div>
  );
};
